import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { deleteCableUpdateImage } from './ServiceUtilitiesCableUpdatingFoto';
//import '../../../Modal/styleModal.css';

const ModalCableFotoDetail = ({ open, onClose, serverImageUrls, setServerImageUrls, setUploadMessage, cableId, user }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleDelete = (fileName) => {
    deleteCableUpdateImage(fileName, cableId, setServerImageUrls, setUploadMessage, user);
  };

  return (
    <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md">
      <DialogContent>
        <div
          className="divFotoRes"
          style={{ width: '100%', height: '100%', paddingRight: '10px' }}
        >
          <label
            style={{
              color: '#dfab01',
              fontSize: '20px',
              fontFamily: 'unset'
            }}
          >
            Фото
          </label>
          <br />
          <hr className="horizontalLineDialog" />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px',
              width: '100%',
              height: '100%',
              overflowY: 'auto'
            }}
          >
            {serverImageUrls.map((image, index) => (
              <div key={index} style={{ marginTop: '10px' }} className='divBodyModalFotoDetail'>
                <img
                  src={image.url}
                  alt={`Изображение с сервера ${index}`}
                  style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer', borderRadius: '10px' }}
                  onClick={() => handleImageClick(image.url)}
                />
                <label style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{image.street}, д. {image.house}, под. {image.entrance}</label>
                
                {user === image.authorId && (
                <button
                  className="buttonIsDeleteModal"
                  style={{fontSize: '14px'}}
                  onClick={() => handleDelete(image.fileName)}
                >
                  Удалить
                </button>
                )}
              </div>
            ))}
          </div>

          {selectedImage && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
              onClick={closeModal}
            >
              <img
                src={selectedImage}
                alt="Полноразмерное изображение"
                style={{ maxWidth: '90%', maxHeight: '90%' }}
              />
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class="buttonIsHideModal">
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCableFotoDetail;

// const ModalCableFotoDetail = ({open, onClose, serverImageUrls}) => {
 
  
//     return (
//       <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md"> 
//       <DialogContent>
//         <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>
          
//             <div style={{ height: '100%' }}> 
              
//               <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование файлов</label>
//               <br/>
             
     
//               <hr className='horizontalLineDialog'/>
//               <div
//                 style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr', 
//                   gap: '10px', 
//                    width: '100%',
//                   height: '100%',
//                   overflowY: 'auto', 
                  

//                 }}
//               >
//                 {serverImageUrls.map((image, index) => (
//                   <div key={index} style={{ marginTop: '10px' }}>
//                     <img
//                       src={image.url}
//                       alt={`Изображение с сервера ${index}`}
//                       style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer' }}
//                       onClick={() => handleImageClick(image.url)}
//                     />
//                     <button className='buttonIsDeleteModal' onClick={() => handleDelete(image.fileName)}>Удалить</button>
//                   </div>
//                 ))}
//               </div>
//             </div>
         
//           {/* {uploadMessage && <p>{uploadMessage}</p>} */}
      
//       {/* Модальное окно для просмотра изображения */}
//       {selectedImage && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: 'rgba(0, 0, 0, 0.8)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000
//           }}
//           onClick={closeModal} 
//         >
//           <img
//             src={selectedImage}
//             alt="Полноразмерное изображение"
//             style={{ maxWidth: '90%', maxHeight: '90%' }}
//           />
//         </div>
//       )}
//     </div>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose} class='buttonIsHideModal'>
//           Закрыть
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default ModalCableFotoDetail;